import React, { Fragment } from 'react'
import { Intro, MultipleChoice } from 'cvs-core'
import image from '../../assets/images/U1-T1-14d.svg'

const data = {
  question:
    'There are many potential health risks associated with vaping/using e-cigarettes. Which is NOT a known potential danger or health risk that these products can cause?',
  inputType: 'radio',
  options: [
    {
      label:
        'The liquid used to vape is dangerous and can be fatal if swallowed.',
    },
    {
      label:
        'Vaping/using e-cigarettes can cause slurred speech and impaired driving.',
    },
    {
      label:
        'Battery operated e-cigarettes can explode while using or when in your pocket.',
    },
    {
      label:
        'Vaping/using e-cigarettes can cause permanent structural changes to your brain.',
    },
  ],
}

const correctInput = {
  [data.question]: data.options[1].label,
}

const feedback = {
  success: {
    title: 'You got it!',
    body: '',
  },
  error: {
    title: 'Sorry, that is incorrect',
    body: '',
  },
  retry: {
    title: 'Not quite, give it another try',
    body: '',
  },
}

export default {
  title: 'Question 4',
  path: '/challenge/question-4',
  content: (
    <Fragment>
      <Intro title="Question 4" img={image} />
      <MultipleChoice
        data={data}
        correctInput={correctInput}
        feedback={feedback}
        score={10}
        partiallyCorrectScoring={true}
      />
    </Fragment>
  ),
}



// WEBPACK FOOTER //
// ./src/data/Challenge/Question4.js